export default "__VITE_ASSET___kvNjSIE__"